// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_XoV","rootNoMargin":"styles_rootNoMargin__1TLj5"};